import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito conocimientos previos en hierbas medicinales?',
    answer: 'Para nada. El manual digital está diseñado exactamente para personas que nunca usaron hierbas medicinales antes. Todo está explicado paso a paso, con medidas exactas, sin tecnicismos y con la explicación de por qué cada combinación funciona.'
  }, {
    question: '¿Los ingredientes se consiguen fácilmente en Argentina?',
    answer: 'Sí. El 90% de las recetas usan ingredientes disponibles en cualquier verdulería, almacén o supermercado argentino: ajo, jengibre, limón, cúrcuma, canela, aceite de oliva y más. No necesitás importar nada ni ir a tiendas especializadas.'
  }, {
    question: '¿Cómo recibo el manual?',
    answer: 'El acceso es inmediato y 100% digital. En cuanto confirmás tu pago, recibís un correo con el enlace de descarga del manual digital completo más los 2 bonos. Podés verlo en tu celular, tablet o computadora al instante.'
  }, {
    question: '¿Puedo usarlo si estoy tomando medicación?',
    answer: 'El manual está diseñado como complemento, no como sustituto de ningún tratamiento médico. Te recomendamos consultar con tu médico antes de incorporar cualquier receta, especialmente si tomás anticoagulantes, hipoglucemiantes o medicación para la presión arterial. Este manual nunca te indicará que abandones un tratamiento prescripto.'
  }, {
    question: '¿Cuánto tarda en verse un resultado?',
    answer: 'Depende de cada persona y del área de enfoque. Algunos lectores reportan cambios en el sueño a los 3-5 días. En digestión, muchos notan diferencia en la primera semana. Para el dolor articular e inflamación, los resultados suelen verse entre la segunda y cuarta semana de aplicación consistente.'
  }, {
    question: '¿Qué pasa si lo pruebo y no me funciona?',
    answer: 'Tenés 7 días para probarlo sin ningún riesgo. Si no notás ninguna diferencia, simplemente escribinos y te devolvemos el dinero completo. Sin preguntas, sin formularios complicados, sin vueltas.'
  }, {
    question: '¿Es solo un recetario o tiene explicaciones científicas?',
    answer: 'Tiene ambas cosas. Cada receta del manual digital incluye la explicación del mecanismo de sinergia — por qué funciona esa combinación específica — respaldada por referencias a estudios publicados en journals científicos internacionales como Frontiers in Pharmacology y Phytotherapy Research.'
  }];
  return <section className="py-20 bg-crema paper-texture" data-id="element-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-marron mb-4" data-id="element-23">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-25" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-oliva/20 rounded-lg overflow-hidden shadow-sm" data-id="element-26">
      <button className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-27">
        <span className="font-bold text-marron text-lg pr-4" data-id="element-28">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-oliva flex-shrink-0" data-id="element-29" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-30" />}
      </button>

      {isOpen && <div className="p-5 pt-0 text-marron-light leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-31">
          <div className="pt-4" data-id="element-32">{answer}</div>
        </div>}
    </div>;
}